class RecommendedProducts extends HTMLElement {
  constructor() {
    super();

    this.init();

    subscribe(PUB_SUB_EVENTS.upsellsUpdate, () => {
      this.init();
      this.getProducts();
    });
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      observer.unobserve(this);

      this.getProducts();
    };

    const rootMargin = this.isCart ? "0px" : "0px 0px 400px 0px";

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: rootMargin,
    }).observe(this);
  }

  init() {
    this.target = this.dataset.target;
    this.route = this.dataset.route;
    this.section = this.dataset.section;
    this.product = this.dataset.product;
    this.limit = this.dataset.limit;
    this.url = `${this.route}?section_id=${this.section}&product_id=${this.product}&limit=${this.limit}`;
    this.type = this.dataset.type;
    this.isCart = this.type === "cart";
    this.items = this.querySelector(`.${this.target}`);
  }

  getProducts() {
    fetch(this.url)
      .then(response => response.text())
      .then(text => this.renderContent(text))
      .finally(() => this.dispatchEvent())
      .catch(e => console.error(e));
  }

  renderContent(content) {
    const html = document.createElement("div");

    html.innerHTML = content;

    const recommendations = html.querySelector(`.${this.target}`);

    this.items.innerHTML = recommendations.innerHTML;
  }

  dispatchEvent() {
    const carousel = this.querySelector("carousel-slider");

    carousel.dispatchEvent(new Event("trigger-init"));
  }
}

customElements.define("recommended-products", RecommendedProducts);
